import styled from '@emotion/styled'
import { Form } from 'antd'
import { RemoveButton as BaseRemoveButton } from '../styles'

export {
  DeleteButton,
  Card,
  FormLabel,
  FormItemTitle,
  FormItemDescription,
  ContentCard,
  PageDescription
} from '../styles'

export const RemoveButton = styled(BaseRemoveButton)`
  position: absolute;
  top: 3px;
  right: 0;
`

export const FormItem = styled(Form.Item)`
  margin-bottom: 0;
`
